<template>

    <fieldset>
        <div class="col-md-12 radio">
            <label>
                <input type="radio" name="shippingSource" @change="sourceChanged">
                <span>An mehrere Lieferadressen senden</span>
            </label>
        </div>
        <div class="clear"></div>
        <new-address v-if="cart.length && enabled && addNewAddress" :saving="true" :countries="countries" ref="newAddress" @save="newAddressSaved" @close="newAddressClose"></new-address>                
        <div v-if="cart.length && enabled">
            <div class="header">
                <div class="image">Bild</div>
                <div class="title">Beschreibung</div>
                <div class="quantity">Menge</div>
                <div class="address">Ort</div>
                <div class="delete">Löschen</div>
                <div class="split">Teilen</div>
            </div>
            <div class="product" v-for="(item, index) in cart" :key="index">
                <input :name="`multi[${index}][id]`"  type="hidden" :value="item.id">
                <input :name="`multi[${index}][address]`" type="hidden" :value="getAddress(item)">
                <input :name="`multi[${index}][source]`"  type="hidden" :value="getSource(item)">
                <div class="image">
                    <img class="img-responsive" :src="item.image" />
                </div>
                <div class="title">
                    <div class="artNum">
                        {{ item.model }}
                    </div>
                    {{ item.name }}
                </div>
                <div class="quantity">
                    <input class="form-control" :name="`multi[${index}][qty]`" type="number" v-model="item.qty" @input="checkStockUpdate(item)" />
                </div>
                <div class="address">
                    <table width="100%">
                        <tr>
                            <td width="20px"></td>
                            <td height="108px">
                                <select2 v-if="addressbook.length" :options="addressbookData" v-model="item.options.address" @change="addressChange(item)"></select2>
                            </td>
                            <td><a class="btn btn-default" title="Add new address" @click.prevent="createNewAddress(item)"  v-if="addressbook.length < 2">+</a></td>
                            <td width="20px"></td>
                        </tr>
                    </table>
                </div>
                <div class="delete"><a class="btn btn-primary" @click.prevent="remove(item, index)"><i class="icon-close"></i></a></div>
                <div class="split"><a class="btn btn-primary" @click.prevent="split(index)"><i class="icon-split"></i></a></div>
            </div>
        </div>
    </fieldset>

</template>

<script>

import Vue from 'vue';
import {cloneDeep} from "lodash";
import Select2 from "../../../../select2/Select2.vue";
import NewAddress from './NewAddress.vue';

export default {

    props: {
        user: {
            required: true,
            default: null
        },
        addressbook: {
            default: () => [],
            required: true
        },
        countries: {
            required: true,
            default: []
        },
    },

    components: {
        Select2,
        NewAddress
    },

    data() {
        return {
            cart: [],
            enabled: false,
            disabled: false,
            addNewAddress: false,
            addNewAddressItem: null
        }
    },
  
    methods: {

        sourceChanged() {
            App.event.fire('shipping.source.changed', { who: 'multiple' });            
        },

        loadCart() {
            new Form({instance:'multi'}).post('/api/cart/content')
            .then(cart => {
                this.cart = cart.items.map((item) => {
                    var i=0;
                    var notFound = 0;
                    if(item.options.superSpecialId)
                    {
                        for(i=0; i < Object.keys(this.addressbook).length; i++) {
                            if(this.addressbook[i]['source']+"-"+this.addressbook[i]['id'] == item.options.superSpecialId) {
                                notFound = 0;
                                break;
                            }
                            notFound = 1;
                        }
                    }
                    if(notFound == 1) {
                        i = 0;
                    }
                    item.options = { address: i };

                    return item;
                });
            });
        },

        getAddress(item) {
            return this.addressbook.length ? this.addressbook[item.options.address].id : null;
        },

        getSource(item) {
            return this.addressbook.length ? this.addressbook[item.options.address].source : null;
        },

        addressChange(item) {
            new Form({item: item}).post('/api/cart/handleMultiShipping')
                .then((response) => {
                    item['rowId'] = response;
                });
        },

        checkStock(item, value) {
            if (this.totalStock(item, value) > parseInt(item.pstock)) {   
                item.qty = this.availableStock(item);
                swal({ 
                    html:true, 
                    title:'', 
                    text: "Lieber Besteller,<br><br>es tut uns leid, dass Ihre Bestellmenge die Anzahl der aktuell auf Lager befindlichen Artikel übersteigt. Bitte reduzieren Sie die Bestellmenge in Übereinstimmung mit dem Lagerbestand.<br><br>Bitte senden Sie eine E-Mail an skokoff@staatsdruckerei.at<br><br>Danke für Ihr Verständnis!",
                    type: "error"
                });
                return false;
            }

            return true;
        },

        checkStockUpdate(item, value) {
            if(item.qty == "" || item.qty < 1) {
                item.qty = 1;
            }
            if (this.totalStock(item, value) > parseInt(item.pstock)) {   
                item.qty = this.availableStock(item);
                swal({ 
                    html:true, 
                    title:'', 
                    text: "Lieber Besteller,<br><br>es tut uns leid, dass Ihre Bestellmenge die Anzahl der aktuell auf Lager befindlichen Artikel übersteigt. Bitte reduzieren Sie die Bestellmenge in Übereinstimmung mit dem Lagerbestand.<br><br>Bitte senden Sie eine E-Mail an skokoff@staatsdruckerei.at<br><br>Danke für Ihr Verständnis!",
                    type: "error"
                });
                return false;
            }
            new Form({item: item}).post('/api/cart/updateMultiShipping');
            return true;
        },

        totalStock(item, value) {
            
            value = value ? parseInt(value) : 0;

            return parseInt(
                this.cart
                    .filter((row) => { return row.id == item.id })
                    .reduce((acc, row) => { return acc + parseInt(row.qty) }, 0)
            ) + value;
        },

        availableStock(item) {
            return parseInt(item.qty) - (this.totalStock(item) - item.pstock);
        },

        split(index) {
            this.disabled = true;
            let item = cloneDeep(this.cart[index]);
            if (this.checkStock(item, item.qty)) {
                new Form({item: item}).post('/api/cart/addMultiShipping')
                    .then((response) => {
                        item['rowId'] = response;
                        this.cart.splice(index, 0, item);
                        this.disabled = false;
                    });
            }
        },

        remove(item, index) {
            new Form({item: item}).post('/api/cart/deleteMultiShipping');
            this.cart.splice(index, 1);
        },

        createNewAddress(item) {
            this.addNewAddress = true;
            this.addNewAddressItem = item;
        },

        newAddressSaved(item) {
            Vue.nextTick(() => {
                this.addNewAddressItem.options.address = this.addressbook.length - 1;
                this.newAddressClose();
            });
        },

        newAddressClose() {
            this.addNewAddress = false;
            this.addNewAddressItem = null;            
        }

    },

    computed: {
        addressbookData() {
            return this.addressbook.map((address, i) => {
                return {
                    'id': i,
                    'text': `${i + 1}. ${address.company}, ${address.street}, ${address.zip} ${address.city}, ${address.countryName}`
                }
            });
        }
    },

    created() {
        App.event.listen('shipping.source.changed', ({who}) => {
            this.enabled = who == 'multiple';
            if (!this.cart.length) {
                this.loadCart();
            }
        });
    }
}
</script>
